var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-jumbotron",
        {
          attrs: {
            header: "Registration",
            lead:
              "All user registered from this page will be submitted for admin approval"
          }
        },
        [
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "3" } }, [_vm._v("Username")]),
              _c(
                "b-col",
                { attrs: { sm: "4" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      type: "text",
                      "aria-describedby": "inputLiveHelp inputLiveFeedback",
                      state:
                        _vm.userRegisterInfo.username.length >= 3 &&
                        _vm.userRegisterInfo.username.length <= 20
                    },
                    model: {
                      value: _vm.userRegisterInfo.username,
                      callback: function($$v) {
                        _vm.$set(_vm.userRegisterInfo, "username", $$v)
                      },
                      expression: "userRegisterInfo.username"
                    }
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { id: "UsernameLiveFeedback" } },
                    [
                      _vm._v(
                        "\n          Username MIN 3 and MAX 20 characters\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "3" } }, [_vm._v("Password")]),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      type: "password",
                      "aria-describedby": "inputLiveHelp inputLiveFeedback",
                      state: _vm.passwordValidation
                    },
                    model: {
                      value: _vm.userRegisterInfo.password,
                      callback: function($$v) {
                        _vm.$set(_vm.userRegisterInfo, "password", $$v)
                      },
                      expression: "userRegisterInfo.password"
                    }
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { id: "PassLiveFeedback" } },
                    [
                      _vm._v(
                        "\n          Password MIN 6 characters with NUMBER and LETTERS\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "3" } }, [_vm._v("Confirm Password")]),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      type: "password",
                      "aria-describedby": "inputLiveHelp inputLiveFeedback",
                      state:
                        _vm.userRegisterInfo.password ===
                          _vm.userRegisterInfo.confirmPassword &&
                        _vm.passwordValidation
                    },
                    model: {
                      value: _vm.userRegisterInfo.confirmPassword,
                      callback: function($$v) {
                        _vm.$set(_vm.userRegisterInfo, "confirmPassword", $$v)
                      },
                      expression: "userRegisterInfo.confirmPassword"
                    }
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { id: "ConPassLiveFeedback" } },
                    [
                      _vm._v(
                        "\n          Password not matching / Incorrectly Entered\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "3" } }, [_vm._v("Full Name")]),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      type: "text",
                      "aria-describedby": "inputLiveHelp inputLiveFeedback",
                      state: !!_vm.userRegisterInfo.fullname
                    },
                    model: {
                      value: _vm.userRegisterInfo.fullname,
                      callback: function($$v) {
                        _vm.$set(_vm.userRegisterInfo, "fullname", $$v)
                      },
                      expression: "userRegisterInfo.fullname"
                    }
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { id: "FullNameLiveFeedback" } },
                    [_vm._v("\n          Full Name cannot be EMPTY\n        ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "3" } }, [_vm._v("Company Name")]),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      type: "text",
                      "aria-describedby": "inputLiveHelp inputLiveFeedback",
                      state: !!_vm.userRegisterInfo.companyName
                    },
                    model: {
                      value: _vm.userRegisterInfo.companyName,
                      callback: function($$v) {
                        _vm.$set(_vm.userRegisterInfo, "companyName", $$v)
                      },
                      expression: "userRegisterInfo.companyName"
                    }
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { id: "CompanyNameLiveFeedback" } },
                    [_vm._v("\n          Company cannot be EMPTY\n        ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "3" } }, [_vm._v("Contractor Email")]),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      type: "email",
                      "aria-describedby": "inputLiveHelp inputLiveFeedback",
                      state: !!_vm.userRegisterInfo.conEmail
                    },
                    model: {
                      value: _vm.userRegisterInfo.conEmail,
                      callback: function($$v) {
                        _vm.$set(_vm.userRegisterInfo, "conEmail", $$v)
                      },
                      expression: "userRegisterInfo.conEmail"
                    }
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { id: "ConEmailLiveFeedback" } },
                    [_vm._v("\n          Email cannot be EMPTY\n        ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "3" } }, [_vm._v("Date of Birth")]),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      type: "date",
                      "aria-describedby": "inputLiveHelp inputLiveFeedback",
                      state: !!_vm.userRegisterInfo.dateOfBirth
                    },
                    model: {
                      value: _vm.userRegisterInfo.dateOfBirth,
                      callback: function($$v) {
                        _vm.$set(_vm.userRegisterInfo, "dateOfBirth", $$v)
                      },
                      expression: "userRegisterInfo.dateOfBirth"
                    }
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { id: "DateOfBirthLiveFeedback" } },
                    [
                      _vm._v(
                        "\n          Date of Birth cannot be EMPTY\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "reg-form-input" },
            [
              _c("b-col", { attrs: { sm: "3" } }, [_vm._v("NRIC/FIN No.")]),
              _c(
                "b-col",
                { attrs: { sm: "2" } },
                [
                  _c("b-form-select", {
                    staticClass: "mb-3",
                    attrs: {
                      "aria-describedby": "inputLiveHelp inputLiveFeedback",
                      state: !!_vm.userRegisterInfo.idType,
                      options: _vm.idType
                    },
                    model: {
                      value: _vm.userRegisterInfo.idType,
                      callback: function($$v) {
                        _vm.$set(_vm.userRegisterInfo, "idType", $$v)
                      },
                      expression: "userRegisterInfo.idType"
                    }
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { id: "IdTypeLiveFeedback" } },
                    [_vm._v("\n          ID type cannot be EMPTY\n        ")]
                  )
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { sm: "4" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      type: "text",
                      "aria-describedby": "inputLiveHelp inputLiveFeedback",
                      state: _vm.nricFinValidation
                    },
                    model: {
                      value: _vm.userRegisterInfo.nricFin,
                      callback: function($$v) {
                        _vm.$set(_vm.userRegisterInfo, "nricFin", $$v)
                      },
                      expression: "userRegisterInfo.nricFin"
                    }
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { id: "NricFinLiveFeedback" } },
                    [
                      _vm._v(
                        "\n          Nric/Fin pattern wrongly entered or EMPTY\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-button",
            {
              attrs: { variant: "success" },
              on: {
                click: function($event) {
                  _vm.showConfirmModal()
                }
              }
            },
            [_vm._v("Submit\n    ")]
          ),
          _c("span", [_vm._v("  ")]),
          _c(
            "b-button",
            {
              attrs: { variant: "danger" },
              on: {
                click: function($event) {
                  _vm.clearRegisterInfo()
                }
              }
            },
            [_vm._v("Reset\n    ")]
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "confirmRegInfo",
          staticClass: "text-left",
          attrs: {
            id: "confirm-reg-info",
            title: "Please confirm your information",
            "hide-footer": ""
          }
        },
        [
          _vm._l(_vm.userRegisterInfo, function(infoItem, index) {
            return _c("p", [
              index !== "password" &&
              index !== "confirmPassword" &&
              index !== "flag"
                ? _c("span", [
                    _c("span", [_vm._v(_vm._s(index) + ":")]),
                    _c("span", [_c("strong", [_vm._v(_vm._s(infoItem))])])
                  ])
                : _vm._e()
            ])
          }),
          _c(
            "b-button",
            {
              attrs: { variant: "success", block: "" },
              on: { click: _vm.userRegister }
            },
            [_vm._v("Confirm\n    ")]
          ),
          _c(
            "b-button",
            {
              attrs: { variant: "outline-danger", block: "" },
              on: {
                click: function($event) {
                  _vm.$refs["confirmRegInfo"].hide()
                }
              }
            },
            [_vm._v("Cancel\n    ")]
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44126d7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44126d7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Register.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-44126d7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Register.vue
// module chunks = 0 7 10